// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
'use strict'
import 'es6-promise/auto'
import Vue from 'vue'
import Timer from './components/Timer.vue'

Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
  el: '#main',
  methods: {
    sendForm () {
      let toggleEvent = null
      let form = this.$el.getElementsByTagName('form')[0]
      try {
        toggleEvent = new Event('submit')
      } catch (error) {
        toggleEvent = document.createEvent('Event')
        toggleEvent.initEvent('submit', true, true)
      }
      // 子コンポーネントのapplyメソッドからイベントが発火される
      form.dispatchEvent(toggleEvent)
    }
  },
  components: {
    Timer
  }
})



// WEBPACK FOOTER //
// ./src/main.js